class MainLogo{
  static SM = 576;
  static MD = 768;
  static LG = 992;
  static XL = 1200;
  static XXL = 1700;
  static XXXL = 1900;

  constructor(element, watchElements=[], darkScreens=[]) {
    this.element = element;
    this.watchElements = watchElements;
    this.darkScreens = darkScreens;
    this.released = 0;
    document.addEventListener('scroll', () => this.onScreenUpdate())
    window.addEventListener('resize', ()=> this.onScreenUpdate());
    this.onScreenUpdate();
  }

  checkVisible(element) {
    const logoRect = this.element.getBoundingClientRect();
    const rect = element.getBoundingClientRect();
    const threshold = logoRect.height;

    if(rect.bottom < threshold)return false;

    return rect.top < threshold;
  }

  getOnScreenElement(nodeList){
    for(let i = 0; i < nodeList.length; i++){
      const element = nodeList.item(i);
      if(this.checkVisible(element))return element;
    }
  }

  offset(){
    if(this.released){
      const rect = this.element.getBoundingClientRect();
      const offsetY = Math.max(Math.min(this.released - window.scrollY, 0), -rect.height);
      if(offsetY === 0 && this.element.style.transform === 'translate3d(0px, 0px, 0px)')return;
      if(offsetY === -rect.height && this.element.style.transform === `translate3d(0px, ${offsetY}px, 0px)`)return;

      this.element.style.transform = `translate3d(0, ${offsetY}px, 0)`;
    }else{

      const footerRect = document.querySelector('.screen-push').getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      if(footerRect.top <  viewHeight * 0.5){
        this.released = window.scrollY;
      }
    }
  }

  onScreenUpdate(){
    this.offset();
    if(window.innerWidth > MainLogo.XXL){
      this.show();
    }else{
      this.getOnScreenElement(this.watchElements) ? this.hide() : this.show();
    }

    this.getOnScreenElement(this.darkScreens) ? this.onDark() : this.onBright();
  }

  hide(){
    if(this.element.classList.contains('opacity-0'))return;
    this.element.classList.add('opacity-0');
  }

  show(){
    if(this.element.classList.contains('opacity-0'))this.element.classList.remove('opacity-0');
  }

  onDark(){
    if(document.body.classList.contains('on-bright'))document.body.classList.remove('on-bright');
    if(document.body.classList.contains('on-dark'))return;
    document.body.classList.add('on-dark');
  }

  onBright(){
    if(document.body.classList.contains('on-dark'))document.body.classList.remove('on-dark');
    if(document.body.classList.contains('on-bright'))return;
    document.body.classList.add('on-bright');
  }

  fixed(){
    if(this.released === 0)return;
    this.released = 0;
  }

  release(){
    if(this.released > 0)return;
    this.released = window.scrollY;
  }
}

export {MainLogo}